export const CALCULATION_REASONS = {
  INITIAL: 'initial',
  APPLY_PROMO: 'applyPromo',
  REMOVE_PROMO: 'removePromo',
  TOGGLE_INSURANCE: 'toggleInsurance',
} as const;
